import React from 'react';
import StatusBadge from '../../../components/common/StatusBadge';
import FilterMultiSelect from '../../../components/table/FilterMultiSelect';
import { state_ru, status_ru } from '../../../helpers/buy';
import { floatRenderer } from '../../../services/formatSvc';
import { getLookupObject } from '../../../utils/table';

const stickyCellStyle = {
  background: 'inherit',
  position: 'sticky',
  left: 0,
  zIndex: 11,
};

export const getColumns = (filters, sourceType, reportType) => {
  const isSourceSf = sourceType === 'sf';
  const onProj = reportType === 'onProj';
  const onStrat = reportType === 'onStrat';

  return [
    {
      title: '№ закупки',
      field: 'num',
      lookup: filters.num,
      filterComponent: FilterMultiSelect,
      minWidth: '200px',
      headerStyle: { ...stickyCellStyle },
      filterCellStyle: { ...stickyCellStyle },
      cellStyle: { ...stickyCellStyle, zIndex: 9, boxShadow: '1px 4px 4px rgba(0,0,0,0.30)' },
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'Название закупки',
      field: 'name',
      minWidth: '250px',
    },
    {
      title: 'Версия закупки',
      field: 'version',
    },
    {
      title: 'Статус',
      field: 'status',
      lookup: filters.status,
      filterComponent: FilterMultiSelect,
      minWidth: '160px',
      render: ({ status }) => <StatusBadge type="buy" status={status} width={150} />,
      _meta: {
        lookup: true,
        lookupLabelsDictionary: status_ru,
      },
    },
    {
      title: 'Состояние',
      field: 'state',
      lookup: filters.state,
      filterComponent: FilterMultiSelect,
      minWidth: '160px',
      render: ({ state }) => <StatusBadge type="buyState" status={state} width={150} />,
      _meta: {
        lookup: true,
        lookupLabelsDictionary: state_ru,
      },
    },
    {
      title: 'Отправлено в 1С',
      field: 'isExported',
      lookup: filters.isExported,
      filterComponent: FilterMultiSelect,
      _meta: {
        lookup: true,
      },
    },
    {
      title: '№ СП',
      field: 'strategyNum',
      hidden: onProj || onStrat,
      lookup: filters.strategyNum,
      filterComponent: FilterMultiSelect,
      minWidth: '120px',
      _meta: {
        lookup: true,
      },
    },
    {
      title: '№ проекта',
      field: 'projNum',
      hidden: onProj,
      lookup: filters.projNum,
      filterComponent: FilterMultiSelect,
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'Наименование проекта',
      field: 'projName',
      hidden: onProj,
      lookup: filters.projName,
      filterComponent: FilterMultiSelect,
      minWidth: '300px',
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'Руководитель проекта',
      field: 'projHead',
      hidden: onProj,
      lookup: filters.projHead,
      filterComponent: FilterMultiSelect,
      minWidth: '150px',
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'Соглашение',
      field: 'agreement',
      hidden: isSourceSf,
      lookup: filters.agreement,
      filterComponent: FilterMultiSelect,
      minWidth: '160px',
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'КБК',
      field: 'bcCode',
      hidden: isSourceSf,
      lookup: filters.bcCode,
      filterComponent: FilterMultiSelect,
      minWidth: '120px',
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'Тип',
      field: 'funding',
      lookup: filters.funding,
      filterComponent: FilterMultiSelect,
      minWidth: '120px',
      _meta: {
        lookup: true,
      },
    },
    {
      title: '№ КВР',
      field: 'costKvr',
      lookup: filters.costKvr,
      filterComponent: FilterMultiSelect,
      minWidth: '120px',
      _meta: {
        lookup: true,
      },
    },
    {
      title: '№ статьи соглашения',
      field: 'costAgr',
      hidden: isSourceSf,
      lookup: filters.costAgr,
      filterComponent: FilterMultiSelect,
      _meta: {
        lookup: true,
      },
    },
    {
      title: 'Введено по закупке, руб.',
      field: 'draftSum',
      minWidth: '135px',
      filtering: false,
      aggregated: true,
      render: ({ draftSum }) => floatRenderer(draftSum),
    },
    {
      title: 'Утверждено на комиссии, руб.',
      field: 'approvedSum',
      minWidth: '135px',
      filtering: false,
      aggregated: true,
      render: ({ approvedSum }) => floatRenderer(approvedSum),
    },
    {
      title: 'Акцепт, руб.',
      field: 'acceptedSum',
      minWidth: '135px',
      filtering: false,
      aggregated: true,
      render: ({ acceptedSum }) => floatRenderer(acceptedSum),
    },
    {
      title: 'Контракт, руб.',
      field: 'contractSum',
      minWidth: '135px',
      filtering: false,
      aggregated: true,
      render: ({ contractSum }) => floatRenderer(contractSum),
    },
    {
      title: 'Оплата, руб.',
      field: 'paymentSum',
      minWidth: '135px',
      filtering: false,
      aggregated: true,
      render: ({ paymentSum }) => floatRenderer(paymentSum),

    },
    {
      title: 'Портфель',
      field: 'portfName',
      hidden: onProj,
      lookup: filters.portfName,
      minWidth: '250px',
      filterComponent: FilterMultiSelect,
      _meta: {
        lookup: true,
      },
    },
  ];
};

export const getFilters = (data) => {
  const columnsMetadata = getColumns({})
    .filter((col) => col._meta && col._meta.lookup)
    .map((col) => ({ field: col.field, lookupLabelsDictionary: col._meta.lookupLabelsDictionary }));

  return columnsMetadata.reduce((acc, col) => {
    const result = getLookupObject(data, col.field);
    if (col.lookupLabelsDictionary) {
      for (const key of Object.keys(result)) result[key] = col.lookupLabelsDictionary[key];
    }

    return { ...acc, [col.field]: result };
  }, {});
};
